var angular = require('angular');
var template = require('./template.pug');
require('../nsPopover')
require("../../filters/linkify");


 angular.module("app.directives").directive('questionHelpTextIcon', function () {
  return {
    restrict: 'E',
    scope: {
      text: "=",
      html: "=",
    },
    replace:true,
    transclude:true,
    template: template,
  }


});
